<ng-container *ngrxLet="event$ as event">
  <mat-list-item *ngIf="event.participants.length > 1">
    <mat-icon matListItemIcon>group</mat-icon>
    <span matListItemTitle>Participants</span>
    <p
      *ngFor="
        let participant of event.participants;
        trackBy: trackByParticipant
      "
      matListItemLine
    >
      {{ participant.name }}
    </p>
  </mat-list-item>
</ng-container>
